var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"outstanding"}},[_c('div',{staticClass:"content"},[_c('GridModelsContainer',{attrs:{"error-models":_vm.errorModels,"load-models":_vm.loadModels,"loading-models":_vm.loadingModels,"models":_vm.models}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }